import React from 'react';
import PropTypes from 'prop-types';
import { TherapyPageTemplate } from '../../templates/therapy-page';

const TherapyPagePreview = ({ entry, widgetFor }) => {
  return (
    <TherapyPageTemplate
      content={widgetFor('body')}
      description={entry.getIn(['data', 'description'])}
      title={entry.getIn(['data', 'title'])}
    />
  );
};

TherapyPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  widgetFor: PropTypes.func,
};

export default TherapyPagePreview;
